import RightBarGroup from './RightBarGroup'
import Select from './Select'
import { ChangeEventHandler, useMemo } from 'react'
import { FontType, getEnabledFeatures } from '@bm-js/atlascloud-shared'
import { useEditorActions, useEditorData } from '../utils/hooks'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

const allFontOptions = [
  {
    key: 'fontInterNunito',
    label: 'Inter & Nunito Sans',
  },
  {
    key: 'fontSofiaPro',
    label: 'Sofia Pro',
  },
]

const FontSelection = () => {
  const { tr } = useTr()
  const { patchConfig } = useEditorActions()
  const { workingConfig, backendResponse } = useEditorData()
  const { website } = backendResponse

  const handleSelect: ChangeEventHandler<HTMLSelectElement> = (e) => {
    patchConfig({ font: e.target.value as FontType })
  }

  const fontOptions = useMemo(() => {
    const enabledFeatures = getEnabledFeatures(website.features)
    return allFontOptions.filter((option) => {
      return !!enabledFeatures.find(
        (feature) => feature.key === `${option.key}`
      )
    })
  }, [website.features])

  const shouldRender = useMemo(() => {
    return fontOptions.length > 1
  }, [fontOptions.length])

  if (!shouldRender) return null

  return (
    <RightBarGroup title='Typsnitt'>
      <Select value={workingConfig.font} onChange={handleSelect}>
        <option disabled value=''>
          {tr(TrKey.editorLeftSelectFontPlaceholder)}
        </option>
        {fontOptions.map((option) => (
          <option key={option.key} value={option.key}>
            {option.label}
          </option>
        ))}
      </Select>
    </RightBarGroup>
  )
}

export default FontSelection
